// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__eLeOp","cell":"ColumnAccessor_cell__3OwAB","firstCellAccent":"ColumnAccessor_firstCellAccent__1Jfax"};